import { Component, OnInit, OnChanges, ElementRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { AgentService } from 'src/app/agent/services/agent.service';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { SettingService } from 'src/app/system-common/services/setting.service';
import * as Chart from 'chart.js';
import { Router } from '@angular/router';

@Component({
  selector: '',
  template: '',
})
export class AgentProductionStatusHandlerComponent
  extends BaseComponent<AgentService>
  implements OnInit, OnChanges
{
  public dateTimeRange1: Date[];
  @ViewChild('dateTimeRange') dateTimeRange: any;
  @ViewChild('frequncy') frequncy: ElementRef;
  @Output() closeChart = new EventEmitter<string>();
  minDate: Date;
  maxDate: Date;
  frequency: string;
  data: Date;
  currFreqModel: any;
  FromDate;
  ToDate;
  chart: Chart;
  chartView;
  series = [];
  inlineChartEvent: string;
  date1 = new Date();
  date = new Date();
  startDate;
  endDate;
  agentProductionGraph: any;
  allocationPercLabels = [];
  pieColorArray = [];
  barGraph: boolean;
  agentProductionBarChartLabels: any[];
  agentProductionLineChartLabels: any[];
  agentProductionBarChartActualData = [];
  agentProductionBarChartPreviousData = [];
  productionSummary: any;
  event: any;
  productionName: any;
  quarterarr: any[];
  montharr: any[];
  month: any;
  year: any;
  productionNameArr: any = [];
  public currentSelectedTheme;

  constructor(agentService: AgentService, public settingService: SettingService, public router: Router) {
    super(agentService);
    this.barGraph = true;
    this.event = 'Q';
    this.inlineChartEvent = 'Q';
    this.quarterarr = ['Jan,Feb,Mar', 'Apr,May,Jun', 'Jul,Aug,Sep', 'Oct,Nov,Dec'];
    this.montharr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    this.month = new Date(Number(this.settingService.getSessionStorageValue('BatchDate'))).getMonth() + 1;
    this.year = new Date(Number(this.settingService.getSessionStorageValue('BatchDate'))).getFullYear();
  }

  ngOnInit() {
    this.currentSelectedTheme = this.settingService.getSessionStorageValue('currentSelectedTheme');
    if (
      (this.currentSelectedTheme != undefined || this.currentSelectedTheme != null) &&
      this.currentSelectedTheme.endsWith('.css')
    ) {
      this.currentSelectedTheme = this.currentSelectedTheme.replace('.css', '');
    }
    setTimeout(() => {
      this.getProductionName();
    }, 10);
  }

  getProductionName() {
    this.service.getProductionName().subscribe(
      (body) => {
        let lookupBody: any = body;
        this.productionNameArr = [];
        if (lookupBody['data']['values'].length > 0) {
          for (let i = 0; i < lookupBody['data']['values'].length; i++) {
            this.productionNameArr.push(lookupBody['data']['values'][i]);
            if (lookupBody['data']['values'][i]['cd'] == this.productionNameArr[0].cd) {
              lookupBody['data']['values'][i]['isProductionSelected'] = true;
              lookupBody['data']['values'][i]['isPerformanceSelected'] = true;
            } else {
              lookupBody['data']['values'][i]['isProductionSelected'] = false;
              lookupBody['data']['values'][i]['isPerformanceSelected'] = false;
            }
          }
        }
        this.initGraph(this.inlineChartEvent, lookupBody['data']['values'][0].cd, undefined);
      },
      (error) => {
        console.log('Error:', error);
      }
    );
  }

  initGraph(chartEvent, productNameDesc, isGraphShow) {
    if (chartEvent != undefined && chartEvent != null && chartEvent != '') this.event = chartEvent;

    if (productNameDesc != undefined && productNameDesc != null && productNameDesc != '')
      this.productionName = productNameDesc;
    if (isGraphShow != undefined && isGraphShow != null)
      this.productionNameArr.filter((productNameArr) => {
        if (productNameArr.cd == productNameDesc) {
          productNameArr.isProductionSelected = !productNameArr.isProductionSelected;
        } else if (productNameArr.isProductionSelected)
          productNameArr.isProductionSelected = !productNameArr.isProductionSelected;
      });

    this.inlineChartEvent = this.event;
    this.agentProductionBarChartActualData = [];
    this.agentProductionBarChartPreviousData = [];
    this.agentProductionBarChartLabels = [];

    this.productionSummary = [];

    this.allocationPercLabels = [];
    if (this.event == 'M') {
      var prev = this.month - 1;
      if (this.month == 1) prev = 12;
      this.allocationPercLabels.push(
        this.service.getMultilingualLabel('Previous') + ' ' + this.montharr[prev - 1]
      );
      this.allocationPercLabels.push(
        this.service.getMultilingualLabel('Current') + ' ' + this.montharr[this.month - 1]
      );
    } else if (this.event == 'Q') {
      var curr;
      if (this.month <= 3) curr = 1;
      else if (this.month >= 4 && this.month <= 6) curr = 2;
      else if (this.month >= 7 && this.month <= 9) curr = 3;
      else if (this.month >= 10 && this.month <= 12) curr = 4;

      var prev = curr - 1;
      if (curr == 1) prev = 4;
      this.allocationPercLabels.push(
        this.service.getMultilingualLabel('Previous') + ' ' + this.quarterarr[prev - 1]
      );
      this.allocationPercLabels.push(
        this.service.getMultilingualLabel('Current') + ' ' + this.quarterarr[curr - 1]
      );
    } else if (this.event == 'Y') {
      this.allocationPercLabels.push(this.service.getMultilingualLabel('Previous') + ' ' + (this.year - 1));
      this.allocationPercLabels.push(this.service.getMultilingualLabel('Current') + ' ' + this.year);
    }

    this.service.getAgentProductionSummary(this.productionName, this.month, this.year).subscribe(
      (agentProductionSummary) => {
        if (agentProductionSummary['data']['ProductionSummary'].length == 0) {
          this.barGraph = false;
          return;
        }
        this.productionSummary = agentProductionSummary;
        this.agentProductionBarChartActualData = [];
        this.agentProductionBarChartPreviousData = [];
        this.agentProductionBarChartLabels = [];
        this.pieColorArray.push('#1f77b4', '#ff7f0e');
        for (let temp of Object.entries(agentProductionSummary['data']['ProductionSummary'])) {
          for (let [key, value] of Object.entries(temp[1])) {
            if (
              ((key == 'mtdPreviousValue' || key == 'mtdActualValue') && this.event == 'M') ||
              ((key == 'qtdPreviousValue' || key == 'qtdActualValue') && this.event == 'Q') ||
              ((key == 'ytdPreviousValue' || key == 'ytdActualValue') && this.event == 'Y')
            ) {
              if (key == 'mtdActualValue' || key == 'qtdActualValue' || key == 'ytdActualValue') {
                this.agentProductionBarChartActualData.push(value);
              }
              if (key == 'mtdPreviousValue' || key == 'qtdPreviousValue' || key == 'ytdPreviousValue') {
                this.agentProductionBarChartPreviousData.push(value);
              }

              if (this.agentProductionBarChartLabels.includes(temp[1]['productCd'])) {
                continue;
              } else {
                this.agentProductionBarChartLabels.push(temp[1]['productCd']);
              }
            }
          }
          this.barGraph = true;
          setTimeout(() => {
            this.barChartBrowser();
          }, 50);
        }
      },
      (error) => {
        console.log('Error:', error);
      }
    );
  }

  barChartBrowser() {
    this.barGraph = true;
    if (this.agentProductionGraph) {
      this.agentProductionGraph.destroy();
      this.agentProductionGraph = null;
    }
    let len = this.agentProductionBarChartLabels.length;
    this.agentProductionGraph = new Chart('barCharts', {
      type: 'bar',
      data: {
        labels: this.agentProductionBarChartLabels,
        datasets: [
          {
            label: this.allocationPercLabels[0],
            fillColor: '#ff7f0e',
            backgroundColor: '#ff7f0e',
            data: this.agentProductionBarChartPreviousData,
            categoryPercentage: this.agentProductionBarChartPreviousData.length == 1 ? 0.2 : 0.4,
            barPercentage: this.agentProductionBarChartPreviousData.length == 1 ? 0.9 : 0.9,
          },
          {
            label: this.allocationPercLabels[1],
            fillColor: '#1f77b4',
            backgroundColor: '#1f77b4',
            data: this.agentProductionBarChartActualData,
            categoryPercentage: this.agentProductionBarChartActualData.length == 1 ? 0.2 : 0.4,
            barPercentage: this.agentProductionBarChartActualData.length == 1 ? 0.9 : 0.9,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        onClick: (e, activeEls) => {
          this.onGraphPointClick(activeEls);
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              let label = data.datasets[tooltipItem.datasetIndex].label || '';
              let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              return `${label}: ${value.toLocaleString()}`;
            },
          },
          bodyFontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
        },
        scales: {
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: '',
                fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
                fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
              },
              gridLines: {
                color: this.currentSelectedTheme === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)',
                zeroLineColor: this.currentSelectedTheme === 'dark' ? '#fff' : 'rgba(10, 10, 10, 0.2)',
                drawBorder: true,
                lineWidth: 1,
              },
              ticks: {
                fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
                fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
              },
            },
          ],
          yAxes: [
            {
              display: true,
              ticks: {
                beginAtZero: true,
                min: 0,
                callback: function (value) {
                  return value.toLocaleString();
                },
                autoSkip: true,
                maxTicksLimit: this.settingService.isMobileViewRendered() ? 4 : 10,
                fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
                fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
              },
              gridLines: {
                color: this.currentSelectedTheme === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)',
                zeroLineColor: this.currentSelectedTheme === 'dark' ? '#fff' : 'rgba(10, 10, 10, 0.2)',
                drawBorder: true,
                lineWidth: 1,
              },
              scaleLabel: {
                display: true,
                labelString: '',
                fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
                fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
              },
            },
          ],
        },
        plugins: {
          datalabels: false,
          plotpadding: 0.2,
          plotBackgroundColor: '#F4F4F4',
          plotBorderWidth: null,
          plotShadow: false,
          credits: {
            enabled: false,
          },
          title: {
            display: true,
            text: null,
          },
        },
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
            fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
            generateLabels: () => {
              var result = [];

              this.allocationPercLabels.forEach((label, i) => {
                if (this.allocationPercLabels[i][0] == this.service.getMultilingualLabel('Previous')[0])
                  result.push({
                    text: this.allocationPercLabels[i],
                    fillStyle: '#ff7f0e',
                  });
                else
                  result.push({
                    text: this.allocationPercLabels[i],
                    fillStyle: '#1f77b4',
                  });
              });
              return result;
            },
          },
        },
      },
    });
  }

  onGraphPointClick(activeEls) {
    if (this.productionName != null && this.productionName != undefined) {
      this.service.productionName = this.productionName;
      this.settingService.setSessionStorageValue('AgentProduction', this.productionName);
    }
    let link = '/search-production-details';
    this.router.navigate([link]);
  }

  // Close the Chart on click of the close button
  onCloseClick() {
    this.closeChart.emit(Chart);
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    // super.ngOnDestroy();
    this.service.clear();
  }
}
